var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.164 6.684c.206-1.193.887-2.15 1.622-2.884a2.723 2.723 0 0 1 4.106.295l1.622 2.169a3 3 0 0 1-.282 3.917l-.11.111a1 1 0 0 0 0 1.415l2.17 2.171a1 1 0 0 0 1.415 0l.111-.111a3 3 0 0 1 3.918-.281l2.185 1.633a2.706 2.706 0 0 1 .293 4.08c-.742.743-1.71 1.435-2.918 1.644-2.224.384-6.487.38-10.503-3.636C2.774 13.188 2.78 8.903 3.164 6.684M6.2 5.214c-.576.576-.956 1.178-1.065 1.81-.309 1.79-.354 5.343 3.072 8.768 3.427 3.428 6.96 3.389 8.749 3.08.645-.111 1.257-.5 1.844-1.087a.706.706 0 0 0-.077-1.064l-2.185-1.634a1 1 0 0 0-1.306.094l-.11.111a3 3 0 0 1-4.244 0l-2.171-2.171a3 3 0 0 1 0-4.243l.111-.11a1 1 0 0 0 .094-1.307L7.29 5.292a.723.723 0 0 0-1.09-.078",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 9a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v1.586l3.293-3.293a1 1 0 1 1 1.414 1.414L17.414 8H19a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;